import { createStore, useStore, StoreApi } from 'zustand';
import { getCountMediaByDate } from '../../api/file/countMediaByDate';
import { CountMedia } from '../../types/CountMedia';

interface CountMediaByDateItem {
    day: string;
    photo: number;
    audio: number;
    video: number;
}

interface CountMediaByDateStore {
    countMedia: CountMediaByDateItem[] | null;
    loading: boolean;
    error: string;
    fetchCountMediaByDate: () => Promise<void>;
    reset: () => void;
}

const countMediaByDateStore: StoreApi<CountMediaByDateStore> = createStore<CountMediaByDateStore>(() => ({
    countMedia: null,
    loading: false,
    error: '',
    fetchCountMediaByDate: async () => {
        countMediaByDateStore.setState({ loading: true, error: '' });
        try {
            const { SmartDVRToken, user } = require('../auth/auth').useAuthStore.getState();
            if (!user || !SmartDVRToken) {
                countMediaByDateStore.setState({ error: 'User or token information is missing.', loading: false });
                return;
            }
            const response = await getCountMediaByDate(SmartDVRToken, user.login);
            if (response && response.success) {
                countMediaByDateStore.setState({ countMedia: response.data, loading: false, error: '' });
            } else {
                countMediaByDateStore.setState({ countMedia: [], loading: false, error: response?.error || 'Unknown error' });
            }
        } catch (error: any) {
            countMediaByDateStore.setState({ error: error.message || 'Unknown error', loading: false });
        }
    },
    reset: () => countMediaByDateStore.setState({ countMedia: null, loading: false, error: '' }),
}));

export const useCountMediaByDateStore = <T>(selector: (state: CountMediaByDateStore) => T): T => useStore(countMediaByDateStore, selector);
